import React, {useContext, useEffect, useState} from 'react'
import { Router, useLocation } from "@reach/router"
import {graphql} from 'gatsby'

import projects from '../projects'

import Home from './home'
import About from './about'
import News from './news'
import Scroll from './scroll'
//import Redirect from './redirect'
//import NotFoundPage from './404'


/*
 * Component
 */
const IndexPage = (props) => {
  //console.log(props.data.posts.edges)
  //console.log(data)
  //console.log(posts)
  // console.log('hej')

  return (
    <>
      <Router>
        {
          projects.map(project =>
            <Home 
              key={project.id}
              path={project.id} 
              pageProps={props}
            />
          )
        }
        <Home 
          path='/'
          pageProps={props}
        />
        <About 
          path='/about/biography'
          pageProps={props}
        />
        <About 
          path='/about/contact'
          pageProps={props}
        />
        {
          props.data.posts.edges.map(({node}) => (
            <News 
              key={node.id}
              path={`news/${node.slug.current}`} 
              pageProps={props}
            />
          ))
        }
        <Scroll
          path='/scroll/*'
          pageProps={props}
        />
      </Router>
    </>
  )
}

export default IndexPage


/*
 * Query
 */
export const query = graphql`
  fragment SanityImage on SanityMainImage {
    crop {
      _key
      _type
      top
      bottom
      left
      right
    }
    hotspot {
      _key
      _type
      x
      y
      height
      width
    }
    asset {
      _id
    }
  }

  query IndexPageQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      description
    }

    posts: allSanityPost(
      sort: {publishedAt: DESC}
      filter: {slug: {current: {ne: null}}, publishedAt: {ne: null}}
      ) {
      edges {
        node {
          id
          publishedAt
          title
          _rawBody(resolveReferences: {maxDepth: 5})
          slug {
            current
          }
        }
      }
    }
  }
`
